/* eslint-disable */
import Grounds from '../index'

export const report = {
    /** 通用统计
     * sessionString: 对应统计文档session字段, 注意对里面的key-value对进行URLEncode. 但整体的session的URLEncode由客户端发送请求时负责拼接.
     * state: 1为立即发送
     */
    stat: (string, state) => {
        Grounds.emit('stat', {
            _time: new Date(),
            type: 'stat',
            string, state
        })
        grounds.stat(string, state);
    },

    /**
     * 上报pv的接口
     * params.id: 当前页面id
     * params.ref: 表明页面是从哪里进入的，就直播频道来说，可以通过地址栏中ref参数获取，如果没有ref参数就不传，客户端会自动加上ref。
     * params.type: 页面类型，根据上方文档进行发送。
     */
    pageStat: params => {
        Grounds.emit('stat', {
            _type: 'page',
            _time: new Date(),
            ...params
        })
        grounds.pageStat(JSON.stringify(params));
    },

    /**
     * 上报行为滚屏
     * type: upscreen，行为类型
     * id: 为当前页面id，规则见上方文档
     * psnum: 滚动的屏幕数（以scrolltop的高度除以屏幕高度，不满一屏的按一屏算）
     */
    actionStat: ({ type, id }, extend = {}) => {
        Grounds.emit('stat', {
            _type: 'action',
            _time: new Date(),
            type, id,
            ...extend
        })
        grounds.actionStat(JSON.stringify(Object.assign({ type, id }, extend)));
    },

    /**
     * 上报曝光数据
     * id: 为当前数据对应的页面的id （如果曝光的是直播里面中的直播，则为 piclive process=live | vlive process=video + liveid）
     * rnum: 数据所在位置，除精选外，其他列表都从1_1开始，依次为2_1，3_1，轮播图为1_1 1_2 1_3
     * reftype: 'editor'
     * ch: 为曝光数据所在的当前页面的id
     * src: 为曝光数据为直播时，src为所在的栏目，曝光数据是栏目时，src是什么呢，channel如何？
     */
    expose: (info) => {
        Grounds.emit('stat', {
            _type: 'expose',
            _time: new Date(),
            ...JSON.parse(info)
        })
        grounds.expose(info);
    },

    /**
     * 发送v统计
     * @param {Object} args jsonstr, 字段定义和page统计一致. vid是必传字段. key-value对由客户端URLEncode
     * @param {Boolean} isEnd 为true立即发送, 为false待到网页页面彻底退出才会发送
     */
    vStat: (args, isEnd) => {
        Grounds.emit('stat', {
            _time: new Date(),
            type: 'vStat',
            args: JSON.stringify(args),
            isEnd
        })
        grounds.vStat(JSON.stringify(args), isEnd);
    },
};
